import Banner from "../Banner/Banner";
import Partner from "../Partner/Partner";
import WeAre from "../We-are/We-are";
import Project from "../Project/Project";
import Technology from "../Technology/Technology";
import FeedBack from "../Feed-Back/FeedBack";
import Staff from "../Staff/Staff";
import ProjectProcess from "../Procedure/Procedure";
import Footer from "../Footer/News/Footer/Footer";
import Header from "../Header/Header";
import TopHead from "../Top-head/TopHead";

import Cooperate from "../Cooperate/Cooperate";
import EventNew from "../EventNew/EventNew";
import Contact from "../Contact/Contact";
import part_mo from "../../assets/images/part_mo.webp";
import part_pc from "../../assets/images/part_pc.webp";

export default function HomeDefault() {
  return (
    <div>
      <div className=" w-full relative overflow-x-hidden">
        <Banner />
      </div>

      <div
        className="relative z-10 bg-center bg-cover bg-no-repeat w-full "
        style={{
          backgroundImage: `url(${
            window.innerWidth < 768 ? part_mo : part_pc
          })`,
        }}
      >
        <Partner />
      </div>
      <WeAre />
      <Project />
      <ProjectProcess />
      <Technology />
      <FeedBack />
      <Staff />
      <Cooperate />
      <EventNew />
      <Contact />
    </div>
  );
}
